import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])
  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    }
    //  else {
    //   body.classList.toggle("vertical-collpsed");
    //   body.classList.toggle("sidebar-enable");
    // }
  }
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            {/* <li className="menu-title">{props.t("Apps")}</li> */}

            <li>
              <Link to="/admin-dashboard" onClick={e => tToggle()}>
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/admin-financial-year" onClick={e => tToggle()}>
                <i className="bx bxs-detail"></i>
                <span>{props.t("Financial Year")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-briefcase-alt-2"></i>
                <span>{props.t("Masters")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-parent-reselling-master"
                  >
                    {props.t("Parent Equipments Products Master")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-reselling-master">
                    {props.t("Equipments Products Master")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-manufacture-master">
                    {props.t("Consumables Products")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-dealer-master">
                    {props.t("Dealers Master")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-existing-customer-master"
                  >
                    {props.t("Dealers Customers Master")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-new-customer-master"
                  >
                    {props.t("Direct Customers Master")}
                  </Link>
                </li>
                {/* <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-demo-product-master"
                  >
                    {props.t("Parent Demo Product Master")}
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-demo-reselling-master"
                  >
                    {props.t("Demo Product Master")}
                  </Link>
                </li> */}
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("Equipments Products")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link onClick={e => tToggle()} to="/admin-maintain-inventory">
                    {props.t("Maintain Inventory")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-view-reselling-product"
                  >
                    {props.t("View Equipments Products")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-tag-list-of-customer"
                  >
                    {props.t("Tagged List of Customers")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-tag-list-of-delear">
                    {props.t("Tagged List of Dealers")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-task"></i>
                <span>{props.t("Consumables Products")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link onClick={e => tToggle()} to="/admin-maintain-inventry">
                    {props.t("Maintain Inventory")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-bulk-consumables-product"
                  >
                    {props.t("Bulk Consumables Products")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-view-dealer-tagged-product"
                  >
                    {props.t("View Dealers Tagged Products")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-dealer-request-for-product"
                  >
                    {props.t("Dealers Request for Products")}
                  </Link>
                </li>
                {/* <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-view-manufactured-product"
                  >
                    {props.t("View Consumables Product")}
                  </Link>
                </li> */}
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-new-order-form-customer"
                  >
                    {props.t("New Orders Form Direct Customers")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-new-order-form-dealer-to-customer"
                  >
                    {props.t("New Orders Form Dealers Customers")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-briefcase"></i>
                <span>{props.t("Demo Products")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-demo-maintain-inventory"
                  >
                    {props.t("Maintain Inventory")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-view-demo-product">
                    {props.t("View Demo Products")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-tagged-product-list"
                  >
                    {props.t("Tagged Products List")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-detail"></i>
                <span>{props.t("Policy Renewal")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link onClick={e => tToggle()} to="/admin-policy-renewal">
                    {props.t("AMC Customers List")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-user-circle"></i>
                <span>{props.t("Dealers")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link onClick={e => tToggle()} to="/admin-dealers-list">
                    {props.t("Dealers List")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-tagged-dealers">
                    {props.t("Tagged Dealers")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("Customers")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-existing-customer-list"
                  >
                    {props.t("Dealers Customers List")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/admin-new-customer-list">
                    {props.t("Direct Customers List")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-product-verification-of-existing-customer"
                  >
                    {props.t("Product Verification of Dealers Customers")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-product-verification-of-new-customer"
                  >
                    {props.t("Product Verification of Direct Customers")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-receipt"></i>
                <span>{props.t("Earnings")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link onClick={e => tToggle()} to="/admin-reselling-products">
                    {props.t("Total Products Sold")}
                  </Link>
                </li>
                {/* <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-manufactured-products"
                  >
                    {props.t("New Order Sold")}
                  </Link>
                </li> */}
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-envelope"></i>
                <span>{props.t("Services")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-service-request-from-customer"
                  >
                    {props.t("Services Requests From Directs Customers")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-services-request-delear-to-customer"
                  >
                    {props.t("Services Requests Dealers Customers")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-services-centric-customer"
                  >
                    {props.t("Services Centric Customers")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-tone"></i>
                <span>{props.t("Refurbished")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-buy-back-request-from-customer"
                  >
                    {props.t("Refurbished Requests From Direct Customers")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/admin-buy-back-request-delear-to-customer"
                  >
                    {props.t("Refurbished Requests From Dealers Customers")}
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
